import { useMemo } from 'react';
import { Offer } from 'queries';
import Proofread from '@app/illu/Small/Proofread.svg';
import CsManager from '@app/illu/Small/CsManager.svg';

export const useSupportOfferIllustration = (offer: Offer) => {
  return useMemo(() => {
    if (offer.internalName === 'Account Manager') {
      return CsManager;
    }
    if (offer.internalName === 'Verify study setup') {
      return Proofread;
    }
    return undefined;
  }, [offer.name]);
};
